const disableMediaContextMenu = true;

//DK users that landed in SV, then chose to go to DK shop
try {
    if(document.referrer.indexOf("callisto-jewellery.com") !== -1) {
        //Redirect from Swedish webshop, determine if it's a 404
        if(document.title.trim().startsWith("404")){
            window.location.replace("/");
        }
    }
} 
catch (error) {
  console.error("Error:", error.message);
} 
//End DK users that landed in SV, then chose to go to DK shop

function isMobile(){
    return window.matchMedia("(max-width: 959px)").matches;
}

function onProductPage(){   
    return  (document.body.classList.contains("template-product"));
}

document.addEventListener("DOMContentLoaded", (event) => { 

    handleMedia();

});

function handleMedia(){
    const videos = document.querySelectorAll('video');
    const imgs = document.querySelectorAll('img');

    if(disableMediaContextMenu){
        imgs.forEach(img => {
            img.setAttribute('oncontextmenu', "return false;");
        });
    }

    if(onProductPage()){  
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                entry.target.onpause = function(){ //after first view it pauses even if visible - so therefor this function
                    if(entry.isIntersecting){ //console.log("Subsequent play")
                        entry.target.play();
                    }
                }
                if (entry.isIntersecting) { //console.log("Play");
                    entry.target.play();
                } else {
                    entry.target.pause(); //console.log("Pause");
                }
            });
        });
        videos.forEach(video => {
            observer.observe(video);
            if(disableMediaContextMenu){
                video.setAttribute('oncontextmenu', "return false;");
            }
        });
    } 
}
